import { createAction } from "@reduxjs/toolkit";

export const initialize = createAction("initialize");

export const setModalOpener = value => (_dispatch, _getState, { hostModal }) =>
  hostModal.setModalOpener(value);

export const openHostModal = () => (_dispatch, _getState, { hostModal }) =>
  hostModal.openHostModal();

export const sendClickToContactCTA = ({ fromSource }) => (
  _dispatch,
  _getState,
  { analyticsService }
) => analyticsService.sendClickToContactCTA({ fromSource });
